import './numResults.scss';

function NumResults({ movies, query }) {
  return (
    <p className='num-results'>
      {query ? `Found ${movies.length} results` : 'there are no requests'}
    </p>
  );
}

export default NumResults;
